import {
  fetchInsights,
  updateInsights,
  getEpisodeById,
  regenerateInsights,
  exportSubtitlesByEpisodeId,
  updateTranscription,
  updateEpisode,
} from "./episode.service";

export const episodeService = {
  fetchInsights,
  updateInsights,
  getEpisodeById,
  regenerateInsights,
  exportSubtitlesByEpisodeId,
  updateTranscription,
  updateEpisode,
};
